import { createSelector } from 'reselect';

const directDownloadSelector = (state) => state.downloads;

export const selectDownloadIds = createSelector(
  [directDownloadSelector],
  (downloads) => downloads.downloadIds
);

export const selectTaskProgress = createSelector(
  [directDownloadSelector],
  (downloads) => downloads.taskProgress || {}
);

export const selectLastExportStatus = createSelector(
  [directDownloadSelector],
  (downloads) => downloads.lastExportStatus
);

export const selectExportMonitor = createSelector(
  [directDownloadSelector],
  (downloads) =>
    downloads.exportMonitor || {
      active: false,
      minimized: false,
      label: 'Applicant export',
    }
);

const toStatus = (id, status = {}) => ({
  id: id || null,
  progress: typeof status.progress === 'number' ? status.progress : 0,
  complete: Boolean(status.complete),
  error: status.error || null,
});

export const selectActiveExportProgress = createSelector(
  [selectDownloadIds, selectTaskProgress, selectLastExportStatus],
  (downloadIds, taskProgress, lastExportStatus) => {
    if (downloadIds?.length) {
      const latest = downloadIds[downloadIds.length - 1];
      const fromMap = taskProgress?.[latest?.id];
      if (fromMap) {
        return toStatus(latest.id, fromMap);
      }
    }

    if (lastExportStatus) {
      return toStatus(lastExportStatus.id, lastExportStatus);
    }

    return toStatus(null);
  }
);
